import FitinsurAPI from './fitinsur-api';

const dates = {
    convert: function (d) {
        // Converts the date in d to a date-object. The input can be:
        //   a date object: returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //   a number     : Interpreted as number of milliseconds
        //                  since 1 Jan 1970 (a timestamp) 
        //   a string     : Any format supported by the javascript engine, like
        //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date
        //                  attributes.  **NOTE** month is 0-11.
        return (
            d.constructor === Date ? d :
                d.constructor === Array ? new Date(d[0], d[1], d[2]) :
                    d.constructor === Number ? new Date(d) :
                        d.constructor === String ? new Date(d) :
                            typeof d === "object" ? new Date(d.year, d.month, d.date) :
                                NaN
        );
    },
    compare: function (a, b) {
        // Compare two dates (could be of any type supported by the convert
        // function above) and returns:
        //  -1 : if a < b
        //   0 : if a = b
        //   1 : if a > b
        // NaN : if a or b is an illegal date
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(a = this.convert(a).valueOf()) &&
                isFinite(b = this.convert(b).valueOf()) ?
                (a > b) - (a < b) :
                NaN
        );
    },
    inRange: function (d, start, end) {
        // Checks if date in d is between dates in start and end.
        // Returns a boolean or NaN:
        //    true  : if d is between start and end (inclusive)
        //    false : if d is before start or after end
        //    NaN   : if one or more of the dates is illegal.
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(d = this.convert(d).valueOf()) &&
                isFinite(start = this.convert(start).valueOf()) &&
                isFinite(end = this.convert(end).valueOf()) ?
                start <= d && d <= end :
                NaN
        );
    },

    addDays: function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
}



const fitinsurapi = new FitinsurAPI();


export default class CacheManager {


    updateCache(message) {
        const cache = localStorage.getItem('persistor');
        if (cache) {
            let item = JSON.parse(cache);
            let list = [...item.dict.filter(x => x.uid != message.uid && x.isoCode != message.isoCode && x.idDomain != message.idDomain && dates.compare(new Date(x.exp), new Date()) == 1)];
            if (list.length >= 50) {
                list.pop();
            }
            list.push(message);
            localStorage.setItem('persistor', JSON.stringify({ lastUpdate: new Date(), dict: [...list] }));
            return true;

        } else {
            localStorage.setItem('persistor', JSON.stringify({ lastUpdate: new Date(), dict: [{...message}] }));
        }
    }

    checkCachedMessage(uid,isoCode,idDomain) {
        const cache = localStorage.getItem('persistor');
        if (cache) {
            let msg = JSON.parse(cache);
          /*   msg.dict.forEach(element => {
                console.log(dates.compare(new Date(element.exp), new Date()));
            }); */
            msg = [...msg.dict.filter(x => dates.compare(new Date(x.exp), new Date()) == 1)];
            msg = msg.find(x => x.uid == uid && x.isoCode == isoCode && x.idDomain == idDomain);
            if (msg) {
                return msg.value;
            } else {
                return false;
            }
        }
        return false;
    }

    getMessage(uid,isoCode,idDomain,token) {
       return new Promise( (success,reject) =>{
        if(!uid && !isoCode && !idDomain && !token){
            reject(false);
        }
        let msg = this.checkCachedMessage(uid,isoCode,idDomain)
        if (msg) {
            success(msg);
        } else {
            fitinsurapi.setAuthToken(token);
            fitinsurapi.getMessage(uid,isoCode,idDomain)
                .then(x => x.json())
                .then((response) => {
                    if (response.ret_code != 200) reject(false);
                    this.updateCache({ uid: uid, isoCode:isoCode, idDomain:idDomain ,value: response.ret_value.messageText, exp:dates.addDays(new Date(),4)});
                    success(response.ret_value.messageText);
                }).catch(() => { reject(false) })
        }
       })
    }

    clearCache(){localStorage.removeItem('persistor');}



}